












































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { UserService } from '@/modules/partners/services/user.service'
import { User, Skill } from '@/modules/core/models'

@Component
export default class PartnerDetail extends Vue {
        @Prop(Number)
        id: number | undefined; // id

        isDataLoaded = false;

        user: User = null;

        get pk () {
          if (this.id === undefined) {
            let pk = Number(this.$route.params.id)
            if (pk === undefined) {
              console.log('pk is not defined')
              // go back to main route
            }
            return pk
          }
          return this.id
        }

        async created () {
          this.user = await UserService.get(this.pk)
          console.log(this.user)
          this.isDataLoaded = true
        }

        get get_avatar_image () {
          const background_colors = ['F9A825', '224177', '00838F', '9C27B0']

          let random_color = background_colors[Math.floor(Math.random() * 3)]

          return `https://eu.ui-avatars.com/api/?name=${this.user.name}+${this.user.surname}&rounded=true&size=128&background=${random_color}&color=fff`
        }
}
